module.exports = __webpack_public_path__ + "img/analyst.f1135953.png";